import { render, staticRenderFns } from "./ExMusic.vue?vue&type=template&id=b2caabc8&scoped=true&"
import script from "./ExMusic.vue?vue&type=script&lang=js&"
export * from "./ExMusic.vue?vue&type=script&lang=js&"
import style0 from "./ExMusic.vue?vue&type=style&index=0&id=b2caabc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2caabc8",
  null
  
)

export default component.exports